<script setup lang="ts">
import { onMounted, ref } from "vue";
import { HomeService } from "~/services/HomeService";

const whatsappIcons = useState<{ icon_url: string; url: string }[]>(
  "home.whatsappIcons",
  () => shallowRef([]),
);
const whatsappButton = ref<HTMLElement>();
const tooltipContent = `
  <h6 class="d-none d-md-block mb-0 py-2 px-2 font-weight-normal text-nowrap">¡Contáctanos en WhatsApp! Has click aquí</h6>
  <div class="d-md-none text-nowrap py-1 px-1">¡Contáctanos en WhatsApp! Has click aquí</div>
`;

const init = async () => {
  const homeService = new HomeService();
  try {
    whatsappIcons.value = await homeService.getBanners("BANNER_WHATSAPP");
  } catch (err) {
    console.error(err);
  }
};

onMounted(async () => {
  if (whatsappButton.value) {
    const { Tooltip } = await import("bootstrap");
    new Tooltip(whatsappButton.value);
  }
  init();
});
</script>

<template>
  <div
    ref="whatsappButton"
    class="whatsapp-button pl-2"
    :class="{ isCustomized: whatsappIcons.length > 0 }"
    data-bs-toggle="tooltip"
    data-bs-placement="left"
    :data-bs-title="tooltipContent"
    data-bs-html="true"
    data-bs-trigger="focus hover"
    data-bs-custom-class="whatsapp-tooltip"
  >
    <a
      v-if="whatsappIcons.length > 0"
      href="https://wa.me/523341605433"
      target="_blank"
      class="d-block"
    >
      <img
        :src="whatsappIcons[0].image"
        width="100"
        height="100"
        class="d-none d-md-inline"
      />
      <img
        :src="
          whatsappIcons[0].sm_image_url
            ? whatsappIcons[0].sm_image_url
            : whatsappIcons[0].image
        "
        width="60"
        height="60"
        class="d-md-none"
      />
    </a>
    <a
      v-else
      href="https://wa.me/523341605433"
      target="_blank"
      class="d-block rounded-circle shadow"
    >
      <img
        src="/images/social/whatsapp-2.svg"
        width="60"
        height="60"
        class="d-none d-md-inline"
      />
      <img
        src="/images/social/whatsapp-2.svg"
        width="48"
        height="48"
        class="d-md-none"
      />
    </a>
  </div>
</template>

<style lang="scss">
@use "@/assets/scss/bootstrap-helpers" as *;

.whatsapp-button {
  position: fixed;
  right: 25px;
  bottom: 60px;
  z-index: 1040;
  a.shadow {
    box-shadow: 0px 3px 12px 0px rgb(39, 36, 36) !important;
  }
  @include media-breakpoint-up(md) {
    right: 15px;
    bottom: 18px;
  }
}
.whatsapp-button.isCustomized {
  right: 25px;
  bottom: 70px;
  @include media-breakpoint-up(md) {
    right: 15px;
    bottom: 38px;
  }
}
.whatsapp-tooltip {
  z-index: 1040;
  .tooltip-inner {
    z-index: 1040;
    max-width: 500px;
  }
}
</style>
